jQuery(document).ready(function() {
	/*----- Mobile menu -----*/
	$(".menu-category__title.has-submenu").on("click", function(e) {
		if ($(window).width() < 768) {
			e.preventDefault();
			$(this).toggleClass("open");
			$(this)
				.siblings("ul")
				.slideToggle();
		}
	});

	/*----- Basic popup -----*/
	$(".popup-trigger").on("click", function(e) {
		e.preventDefault();
		var popupId = $(this).attr("data-popupClass");

		$("." + popupId).fadeIn(300);
		$(".popup-mask").fadeIn(300);

		if (popupId == "menu-popup" && $(window).width() < 768) {
			$("body").addClass("no-scroll");
		}

		if (popupId == "map-popup") {
			mapSetHeight();
		}

        /**
		 * Petr 01.11.2018 - při otevření popup vyhledávání nastaví focus
         */
        $("#search_bar_input").focus();
	});

	$(".basic-popup__close").on("click", function() {
		$(this)
			.closest(".basic-popup")
			.fadeOut(300);
		$(".popup-mask").fadeOut(300);
		$("body").removeClass("no-scroll");
	});

	$(".popup-mask").on("click", function() {
		$(this).fadeOut(300);
		$(".basic-popup").each(function() {
			$(this).fadeOut(300);
		});
		$("body").removeClass("no-scroll");
	});

	/*----- Radio buttons -----*/
	$(".radio-group label").on("click", function() {
		$(".radio-group label").each(function() {
			$(this).removeClass("checked");
		});

		$(this).addClass("checked");
	});

    $(".hp-carousel").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

	/*----- HP carousel -----*/
	$(".hp-carousel").slick({
		arrows: false,
		lazyLoad: "progressive",
		dots: true,
		autoplay: true,
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
		//fade: true,
	});

	/*----- Ad sales carousel -----*/
	$(".ad-block__sales").slick({
		infinite: false,
		lazyLoad: "progressive",
		slidesToShow: 4,
		slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},

			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
	});

    $(".ad-block__sales").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

	/*----- Ad serials carousel -----*/
	$(".ad-block__serials").slick({
		infinite: false,
		lazyLoad: "progressive",
		slidesToShow: 4,
		slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},

			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
	});

    $(".ad-block__serials").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

    /*----- Annonce sales carousel -----*/
    $(".annonce-block__sales").slick({
        infinite: false,
        lazyLoad: "progressive",
        slidesToShow: 4,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
    });

    $(".annonce-block__sales").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

    /*----- Annonce serials carousel -----*/
    $(".annonce-block__serials").slick({
        infinite: false,
        lazyLoad: "progressive",
        slidesToShow: 4,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
    });

    $(".annonce-block__serials").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

    /*----- House detail block carousel -----*/
	//$(".house-detail-block>div").matchHeight();

	$(".house-detail-block__carousel").slick({
		arrows: true,
		lazyLoad: "progressive",
		dots: false,
		autoplay: false,
		fade: true,
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
	});

    $(".house-detail-block__carousel").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

	$(".sale-detail-block__carousel").slick({
		arrows: true,
		lazyLoad: "progressive",
		dots: false,
		autoplay: false,
		fade: true,
        useAutoplayToggleButton: false,   // přidá tlačítko Pauza/Přehrát
        regionLabel: "Carousel",  // pro screen readery
        instructionsText: "Použijte šipky doleva a doprava pro změnu snímku."
	});

    $(".sale-detail-block__carousel").on("init", function (event, slick) {
        // Zajistí, že po inicializaci jsou odkazy v neaktivních slidech nefokusovatelné
        setAriaTabindexFix();
    }).on("afterChange", function (event, slick, currentSlide) {
        // Upraví tabindex po každé změně slide
        setAriaTabindexFix();
    });

    currentSlideFn();
	// On after slide change
	$(".house-detail-block__carousel, .sale-detail-block__carousel").on(
		"afterChange",
		function() {
			currentSlideFn();
		}
	);

    // Helper funkce pro odstranění focusu z neviditelných slide
    function setAriaTabindexFix() {
        $(".hp-carousel .slick-slide").each(function () {
            const $slide = $(this);
            const $focusable = $slide.find("a, button, input, textarea, select");

            if ($slide.attr("aria-hidden") === "true") {
                $focusable.attr("tabindex", "-1");
            } else {
                $focusable.removeAttr("tabindex");
            }
        });
    }

	/*----- Gallery layout carousel -----*/

	// Get the current slide
	function currentSlideFn() {
		var currentSlide = $(
			".house-detail-block__carousel, .sale-detail-block__carousel"
		).slick("slickCurrentSlide");
		var slideCount = $(
			".house-detail-block__carousel-item, .sale-detail-block__carousel-item"
		).length;
		$(
			".house-detail-block__picture-count span, .sale-detail-block__picture-count span"
		).text(currentSlide + 1 + "/" + slideCount);
	}

	/*----- Fancybox -----*/
	$("[data-fancybox]").fancybox({
		buttons: ["close"]
	});

	/*----- Aside block toggle -----*/
	$(".aside-block__heading-button").on("click", function() {
		$(this)
			.closest(".aside-block")
			.children(".aside-block__content")
			.toggleClass("open");
	});

	/*----- Houses tabs -----*/
	$(".houses-tab-btn").on("click", function() {
		var tabID = $(this).data("tab");

		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this)
				.prev()
				.removeClass("active-prev");
		} else {
			$(".houses-tab-btn").each(function() {
				$(this).removeClass("active");
				$(this)
					.prev()
					.removeClass("active-prev");
			});

			$(this).addClass("active");
			$(this)
				.prev()
				.addClass("active-prev");
		}

		if ($("#" + tabID).is(":visible")) {
			$("#" + tabID).hide();
		} else {
			$(".houses-tab").each(function() {
				$(this).hide();
			});

			$("#" + tabID).show();
		}
	});

	/*----- Checkboxes -----*/
	$(".inline-checkbox label").on("click", function() {
		$(this).toggleClass("checked");
	});
	$(".company-block__checkbox label").on("click", function() {
		$(this).toggleClass("checked");
	});

	/*----- Selectboxes -----*/
	$(".inline-selectbox select").selectric();
	$(".block-selectbox select").selectric();
	$(".listing-bar__sort select").selectric();
	$(".catalog-search-region-select").selectric();

	/*----- Scroll to -----*/
	if ($(window).width() < 768) {
		$(".houses-tab-btn").on("click", function() {
			var targetEl = "#" + $(this).data("tab");

			if ($(targetEl).is(":visible")) {
				moveToHtmlTarget($(targetEl), 20, 0);
			}
		});
	}

	/*----- Houses listing switch -----*/
	$(".listing-bar-switch").on("click", function() {
		$(".aside-main").toggle();
		$(".main-content").toggleClass("col-md-pull-4");
		$(".main-content").toggleClass("col-md-8");
		$(".main-content").toggleClass("col-md-12");
		$(".main-content").toggleClass("extended");
		$(".listing-bar").toggleClass("extended");

		$(".house-block").each(function() {
			$(this).toggleClass("col-md-4");
		});

		$(".house-block").matchHeight();

		gallerySortCatalog();
	});

	/*----- Listing bar -----*/
	/*
	if ($(window).width() < 768) {
		$('.listing-bar').detach().appendTo('.aside-main');
	}
	*/

	$(".listing-bar__filter").on("click", function() {
		$(this).hide();
		$(".filter-tab").show();
		$(".search-by-name").show();
	});

	/* ----- Tooltip -----*/

	$(".js-clipboard-btn").tooltip({
		trigger: "click",
		placement: "bottom"
	});

	/*Clipboard ini*/
	if ($(".js-clipboard-btn").length) {
		var clipboard = new ClipboardJS(".js-clipboard-btn");

		clipboard.on("success", function(e) {
			setTooltip("Zkopírováno!");
			hideTooltip();
		});

		clipboard.on("error", function(e) {
			setTooltip("Chyba!");
			hideTooltip();
		});
	}

	matchHeightAll();
	footerCollapse();
	regionDropdown();
	companyAnchor();
	tagsBarCollapse();
	tagsBarToggle();

	gallerySort();
	galleryLayout();
	sharePopup();
	//favIconSwitch();
	menuHoverDelay();
	menuHoverDelayOtherItems();
	userBoxToggle();

	uploadNameReader();
	priorityNavInit();

	popUpCloseBtn();
	if ($(window).width() > 767) {
		companyListNav();
	}
});

/*----- Gallery sorting -----*/

function galleryLayout() {
	if ($(window).width() < 992) {
		$(".aside-gallery")
			.detach()
			.insertAfter($(".main-content-gallery"));
	} else {
		$(".aside-gallery")
			.detach()
			.insertBefore($(".main-content-gallery"));
	}
}

function gallerySort() {
	if ($(".gallery-grid").length) {
		if ($(window).width() > 991) {
			if ($(".catalog-item.gallery-grid__item").length) {
				gallerySortCatalog();
			} else {
				gallerySortCol6();
			}
		} else if ($(window).width() > 767) {
			gallerySortCol4();
		} else if ($(window).width() < 768) {
			gallerySortCol2();
		}
	}
}

function gallerySortCol2() {
	var lineCount = 0;

	$(".gallery-grid__item").each(function() {
		$(this).addClass("unsorted");
	});

	sortLoop();

	function sortLoop() {
		if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--2")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			sortLoop();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1") &&
			$(".gallery-grid__item--1.unsorted").eq(1).length
		) {
			$(".gallery-grid__item--1.unsorted")
				.eq(1)
				.detach()
				.insertAfter($(".unsorted").first());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			sortLoop();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1") &&
			!$(".gallery-grid__item--1.unsorted").eq(1).length
		) {
			$(".unsorted")
				.first()
				.detach()
				.insertAfter($(".unsorted").last());
			$(".unsorted")
				.last()
				.removeClass("unsorted");
			sortLoop();
		}
	}
}

function gallerySortCol4() {
	var lineCount = 0;

	$(".gallery-grid__item").each(function() {
		$(this).addClass("unsorted");
	});

	firstTwo();

	function firstTwo() {
		lineCount = 0;

		for (var i = 0; i < 2; i++) {
			if (
				$(".unsorted")
					.first()
					.hasClass("gallery-grid__item--2")
			) {
				lineCount += 2;
			} else {
				lineCount += 1;
			}

			$(".unsorted")
				.first()
				.removeClass("unsorted");
		}

		switch (lineCount) {
			case 4:
				rowCount4();
				break;

			case 3:
				rowCount3();

				break;

			case 2:
				rowCount2();

				break;
		}
	}

	function rowCount4() {
		firstTwo();
	}

	function rowCount3() {
		if ($(".gallery-grid__item--1.unsorted").length) {
			if ($(".unsorted").eq(1).length) {
				$(".gallery-grid__item--1.unsorted")
					.first()
					.detach()
					.insertBefore($(".unsorted").first());
			}

			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else {
			$(".gallery-grid__item--1")
				.last()
				.detach()
				.insertAfter($(".gallery-grid__item").last());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		}
	}

	function rowCount2() {
		if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--2")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1") &&
			$(".gallery-grid__item--1.unsorted").eq(1).length
		) {
			$(".gallery-grid__item--1.unsorted")
				.eq(1)
				.detach()
				.insertAfter($(".unsorted").first());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else if ($(".gallery-grid__item--1.unsorted").length) {
			$(".gallery-grid__item--1.unsorted")
				.detach()
				.insertAfter($(".gallery-grid__item").last());
			firstTwo();
		} else {
			console.log("dead end");
		}
	}
}

function gallerySortCol6() {
	var lineCount = 0;

	$(".gallery-grid__item").each(function() {
		$(this).addClass("unsorted");
	});

	firstTwo();

	function firstTwo() {
		lineCount = 0;

		for (var i = 0; i < 2; i++) {
			if (
				$(".unsorted")
					.first()
					.hasClass("gallery-grid__item--2")
			) {
				lineCount += 2;
			} else {
				lineCount += 1;
			}

			$(".unsorted")
				.first()
				.removeClass("unsorted");
		}

		switch (lineCount) {
			case 4:
				rowCount4();
				break;

			case 3:
				rowCount3();

				break;

			case 2:
				rowCount2();

				break;
		}
	}

	//Options of lineCount
	function rowCount4() {
		if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--2")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1") &&
			$(".gallery-grid__item--1.unsorted").eq(1).length
		) {
			$(".gallery-grid__item--1.unsorted")
				.eq(1)
				.detach()
				.insertAfter($(".unsorted").first());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else if ($(".gallery-grid__item--2.unsorted").first().length) {
			$(".gallery-grid__item--2.unsorted")
				.first()
				.detach()
				.insertBefore($(".unsorted").first());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else {
			console.log("dead end 1");
		}
	}

	function rowCount3() {
		if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			rowCount4();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--2") &&
			$(".gallery-grid__item--1.unsorted").first().length
		) {
			$(".gallery-grid__item--1.unsorted")
				.first()
				.detach()
				.insertAfter($(".unsorted").first());
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			firstTwo();
		} else {
			console.log("dead end 2");
		}
	}

	function rowCount2() {
		if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--1")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			rowCount3();
		} else if (
			$(".unsorted")
				.first()
				.hasClass("gallery-grid__item--2")
		) {
			$(".unsorted")
				.first()
				.removeClass("unsorted");
			rowCount4();
		} else {
			console.log("dead end 3");
		}
	}
}

function gallerySortCatalog() {
	if ($(".listing-bar.extended").length) {
		gallerySortCol6();
	} else if ($(".listing-bar").length) {
		gallerySortCol4();
	}
}

// Match height
function matchHeightAll() {
	$(".footer-block-wrap").matchHeight();
	$(".menu-category").matchHeight();
	$(".sub-menu-block").matchHeight();
	$(".product-block").matchHeight();
	$(".ad-block__serial-title").matchHeight();
	$(".house-block").matchHeight();
	$(".houses-tab-btn__text").matchHeight();
	$(".serial-list-block").matchHeight();
	$(".serial-list-block__header").matchHeight();
	$(".serial-detail-block").matchHeight();
	$(".gallery-block__heading").matchHeight();
	$(".edit-block__heading").matchHeight();
	$(".video-link").matchHeight();
	$(".document-link").matchHeight();
}

// Map set height
function mapSetHeight() {
	var popupH = $(".map-popup").height();

	$(".popup-map-wrap").height(popupH - 100);
}

//Footer blocks collapse
function footerCollapse() {
	$(".footer-block")
		//.find("h2")
		.find(".h2")
		.on("click", function() {
			if ($(window).width() <= 575) {
				$(this)
					.closest(".footer-block")
					.find(".footer-block-inner")
					.slideToggle();
				$(this).toggleClass("open");
			}
		});
}

function companyAnchor() {
	$(".company__list a").on("click", function(e) {
		e.preventDefault();
		var targetEl = $(this).attr("href");
		if ($(targetEl).is(":visible")) {
			moveToHtmlTarget($(targetEl), 20, 0);
		}
	});
}

//TagsBarTwoRowsCollapse
function tagsBarCollapse() {
	if ($(".tags-bar").length) {
		tagsBarOffset = $(".tags-bar").offset().top;
		tagsBarOffset = Math.round(tagsBarOffset);
		tagBarTagHeight = $(".tags-bar .tags-bar__tag").outerHeight(true);
		tagBarTagHeight = Math.round(tagBarTagHeight);

		offsetLimit = tagBarTagHeight + tagsBarOffset;
		offsetLimit = Math.round(offsetLimit);

		tagsBarHide(offsetLimit);
	}
}

function tagsBarToggle() {
	$(".tags-bar__link").on("click", function(e) {
		e.preventDefault();
		if ($(".tags-bar__link").hasClass("open")) {
			tagsBarCollapse();
			var dataText = $(".tags-bar__link").attr("data-text-open");
			$(".tags-bar__link").text(dataText);
			$(".tags-bar__link").removeClass("open");
		} else {
			$(".tags-bar__tag").removeClass("js-tag-hidden");
			$(".tags-bar__tag").removeAttr("style");
			//$(".tags-bar__link").hide();
			$(".tags-bar__link").addClass("open");
			var dataText = $(".tags-bar__link").attr("data-text-close");
			$(".tags-bar__link").text(dataText);
		}
	});
}

function tagsBarHide(offsetLimit) {
	$(".tags-bar .tags-bar__tag").each(function(index) {
		if ($(this).offset().top > offsetLimit + 20) {
			$(this).addClass("js-tag-hidden");
		}
	});
	if ($(".tags-bar .js-tag-hidden").length) {
		$(".tags-bar .js-tag-hidden").hide();

		$(".tags-bar")
			.find(".tags-bar__tag:visible:last")
			.addClass("js-tag-hidden");
		$(".tags-bar")
			.find(".tags-bar__tag:visible:last")
			.hide();

		$(".tags-bar")
			.find(".tags-bar__tag:visible:last")
			.addClass("js-tag-hidden");
		$(".tags-bar")
			.find(".tags-bar__tag:visible:last")
			.hide();
	} else {
		$(".tags-bar__link").hide();
	}
}

function setTooltip(message) {
	$(".js-clipboard-btn")
		.tooltip("hide")
		.attr("data-original-title", message)
		.tooltip("show");
}

function hideTooltip() {
	setTimeout(function() {
		$(".js-clipboard-btn").tooltip("hide");
	}, 1000);
}

function sharePopup() {
	$(".icon-share").on("click", function(e) {
		e.preventDefault();
		$(".share-popup").fadeIn(300);
	});

	$(".share-popup__close").on("click", function(e) {
		e.preventDefault();
		$(".share-popup").fadeOut(300);
	});
}

function favIconSwitch() {
	$(".fav-icon").on("click", function(e) {
		e.preventDefault();
		$(this).fadeOut();
	});
}

function popUpCloseBtn() {
	$(".btn-close-popup").on("click", function(e) {
		e.preventDefault();
		$(this)
			.closest(".basic-popup")
			.fadeOut(300);
		$(".popup-mask").fadeOut(300);
		$("body").removeClass("no-scroll");
	});
}

function menuHoverDelay() {
	$(".menu-main > li.has-sub-large").hover(
		function() {
			$(this)
				.find(".sub-menu-large")
				.stop(true)
				.delay(500)
				.fadeIn();
		},
		function() {
			$(this)
				.find(".sub-menu-large")
				.stop(true)
				.delay(500)
				.fadeOut();
		}
	);
}

function menuHoverDelayOtherItems() {
	$(".menu-main > li").hover(
		function() {
			$(this)
				.find(".sub-menu")
				.stop(true)
				.delay(500)
				.fadeIn();
		},
		function() {
			$(this)
				.find(".sub-menu")
				.stop(true)
				.delay(500)
				.fadeOut();
		}
	);
}

function userBoxToggle() {
	$(".header-login-btn").on("click", function(e) {
		e.preventDefault();
		$(".user-box").fadeToggle();
	});
}

function companyListNav() {
	var show = false;
	$(".sub-menu-item").show();

	$(".sub-menu-item li").each(function() {
		if ($(this).css("display") != "none") {
			//alert("zivak");
			show = true;
		}
	});
	if (!show) {
		$(".sub-menu-item").hide();
	}
}

function uploadNameReader() {
	$(".add-file-container input").on("change", function(e) {
		var fileName = e.target.files[0].name;
		$(".add-file-container .filename").html(fileName);
	});
}

function priorityNavInit() {
	/* Initiate priorityNav */
	priorityNav.init({
		mainNavWrapper: ".company-nav",
		navDropdownLabel: "Další"
	});
}

// On window resize
$(window).resize(function() {
	matchHeightAll();
	gallerySort();
	galleryLayout();
	//companyPriorityNavigationResize();

	if ($(window).width() > 767) {
		$(".footer-block h2").removeClass("open");
		$(".footer-block-inner").removeAttr("style");
		$(".menu-category__title")
			.siblings("ul")
			.removeAttr("style");
		$(".region-list-block__row").removeAttr("style");
		tagsBarCollapse();
		companyListNav();
	}
});

//Choose Region dropdown
function regionDropdown() {
	$(".region-list-block__button").on("click", function(e) {
		$(".region-list-block__row").slideToggle();
	});
}

//if IE9
if (document.all && !window.atob) {
	$("input[type=text]").each(function() {
		var placeholder = $(this).attr("placeholder");

		$(this).val(placeholder);
	});

	$("input[type=text]").on("click", function() {
		$(this).val("");
	});
}
